/* Reusable PoP slider. Markup:
   <div class="pop-slider" data-pop-slider>
     <div class="pop-slider__track" data-pop-track> ...slides... </div>
     <div class="pop-slider__nav">
       <button class="pop-slider__arrow" data-pop-prev>…</button>
       <button class="pop-slider__arrow" data-pop-next>…</button>
     </div>
   </div>
   Self-contained: native scroll-snap + prev/next + pointer drag. No theme deps. */
(function () {
  // Explicit ScrollOptions override the CSS scroll-behavior property, so
  // reduced-motion has to be honoured here, not in the stylesheet.
  function scrollBehavior() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
  function init(root) {
    if (root.dataset.popSliderReady) return;
    root.dataset.popSliderReady = '1';
    var track = root.querySelector('[data-pop-track]');
    if (!track) return;
    var prev = root.querySelector('[data-pop-prev]');
    var next = root.querySelector('[data-pop-next]');
    var loopMode = root.hasAttribute('data-pop-loop') || parseInt(root.dataset.popAutoplay || '0', 10) > 0;

    function step() {
      var custom = parseFloat(root.dataset.popStep || '0');
      if (custom > 0) return custom;
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    var nav = root.querySelector('.pop-slider__nav');
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      if (nav) nav.style.display = max > 2 ? '' : 'none';
      if (!prev || !next) return;
      if (loopMode) { prev.disabled = false; next.disabled = false; return; }
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () {
      var pmax = track.scrollWidth - track.clientWidth - 1;
      if (loopMode && track.scrollLeft <= 0) { track.scrollTo({ left: pmax, behavior: scrollBehavior() }); }
      else { track.scrollBy({ left: -step(), behavior: scrollBehavior() }); }
    });
    if (next) next.addEventListener('click', function () {
      var nmax = track.scrollWidth - track.clientWidth - 1;
      if (loopMode && track.scrollLeft >= nmax - 1) { track.scrollTo({ left: 0, behavior: scrollBehavior() }); }
      else { track.scrollBy({ left: step(), behavior: scrollBehavior() }); }
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    // pointer drag
    var down = false, startX = 0, startLeft = 0, moved = false, capturedId = null;
    track.addEventListener('pointerdown', function (e) {
      down = true; moved = false; startX = e.pageX; startLeft = track.scrollLeft;
      capturedId = null;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4 && !moved) {
        moved = true;
        // only capture the pointer once we've crossed the drag threshold — keeps normal clicks routed to child links
        try { track.setPointerCapture(e.pointerId); capturedId = e.pointerId; } catch (err) {}
      }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    function end() {
      down = false;
      if (capturedId !== null) { try { track.releasePointerCapture(capturedId); } catch (err) {} capturedId = null; }
      // The post-drag click fires before timers, so this still suppresses it —
      // but `moved` doesn't stay latched and kill later keyboard activations.
      if (moved) { window.setTimeout(function () { moved = false; }, 0); }
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);
    // prevent click navigation right after a drag (e.detail === 0 = keyboard)
    track.addEventListener('click', function (e) { if (moved && e.detail !== 0) { e.preventDefault(); e.stopPropagation(); } }, true);

    // autoplay (opt-in: data-pop-autoplay="<ms>"); advances one item, loops back to the start at the end
    var apMs = parseInt(root.dataset.popAutoplay || '0', 10);
    if (apMs > 0) {
      var apTimer = null;
      var apAdvance = function () {
        if (document.hidden) return; // throttled timers still fire in background tabs
        var apMax = track.scrollWidth - track.clientWidth - 1;
        if (apMax <= 2) return;
        if (track.scrollLeft >= apMax - 1) { track.scrollTo({ left: 0, behavior: scrollBehavior() }); }
        else { track.scrollBy({ left: step(), behavior: scrollBehavior() }); }
      };
      var apPlay = function () { if (!apTimer) { apTimer = window.setInterval(apAdvance, apMs); } };
      var apPause = function () { if (apTimer) { window.clearInterval(apTimer); apTimer = null; } };
      root.addEventListener('pointerenter', apPause);
      root.addEventListener('pointerleave', apPlay);
      root.addEventListener('pointerdown', apPause);
      track.addEventListener('focusin', apPause);
      var apReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!apReduce) { apPlay(); }
    }
  }
  function boot() { document.querySelectorAll('[data-pop-slider]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
